import { useEffect, useState } from 'react'
import useBasketStore from '../context/BasketStore'
import { recoverSavedParts } from '../services/basketRecovery'
import { needsPartRecovery, partRecoveryKey } from '../utils/basketRecovery'

export const useSavedPartRecovery = (region: string) => {
  const items = useBasketStore(state => state.basketItems)
  const key = partRecoveryKey(items)
  const needsRecovery = items.some(needsPartRecovery)
  const [failure, setFailure] = useState<{ key: string; message: string } | null>(null)
  const [attempt, setAttempt] = useState(0)
  const requestKey = `${region.toLowerCase()}|${key}`

  useEffect(() => {
    if (!needsRecovery) return
    let active = true
    setFailure(null)
    recoverSavedParts(useBasketStore.getState().basketItems, region).then(recovered => {
      if (!active) return
      const store = useBasketStore.getState()
      if (partRecoveryKey(store.basketItems) !== key) return
      recovered.forEach(item => store.updateBasketItem(item.id, {
        colourWay: item.colourWay, name: item.name, price: item.price,
      }))
    }).catch(() => {
      if (active) setFailure({ key: requestKey, message: 'We couldn’t restore your saved replacement parts. Please retry, or contact support@kibu.family for help with your choices.' })
    })
    return () => { active = false }
  }, [key, region, needsRecovery, attempt, requestKey])

  const error = needsRecovery && failure?.key === requestKey ? failure.message : null
  return {
    needsRecovery,
    isRecovering: needsRecovery && !error,
    recoveryError: error,
    retryRecovery: () => { setFailure(null); setAttempt(value => value + 1) },
  }
}
